/**
 * 
 * @fileOverview jquery plugin cy-ln
 * <iframe src='../preview.html' width='100%' height='500' iframeborder='0' style='border:1px solid #ccc'></iframe>
 * 
 * @example
//html
<input id="test" type="text" data-change="true" placeholder="2015/10/18">

//javascript
$('#test').cy_ln({
	monthCount: 1,
	minYear: 10,
	maxYear: 10,
	minDate: moment().subtract(100, 'years'),
	maxDate: moment(),
	weekdayName: ['日','一','二','三','四','五','六'],
	changeMonthYear: true
});

 * @version 1.0.0
 * @author jivecheng
 * @see external:"jQuery.fn".cy_ln
 * @requires jquery
 */

/**
 * See the jQuery Library  (http://jquery.com/) for full details.  This just
 * documents the function and classes that are added to jQuery by this plug-in.
 * @external jQuery
 * @see {@link http://api.jquery.com/jQuery/}
 * 
 */

/**
 * The jQuery plugin namespace.
 * @external "jQuery.fn"
 * @see {@link http://learn.jquery.com/plugins/|jQuery Plugins}
 * @type {object}
 */

/**
 * The moment plugin namespace.
 * @external moment
 * @see {@link http://momentjs.com/docs/|Moment.js Documentation}
 * @type {object}
 */

/**
 * @external HTMLElement
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement}
 */
(function($, moment) {
	'use strict';
	var ModuleName = 'cy_ln';

	var Module = function (element, options) {
		this.input = element;
		this.$input = $(element);
		this.options = options;
		this.timer = null;
	};
	/**
     * [DEFAULTS description]
     * @typedef PluginOption
     * @type {object}
     * @property {string} [hideArea='body'] hideArea
     * @property {string} [prev='<a class="btn"></a>'] prev
     * @property {string} [next='<a class="btn"></a>'] next
     * @property {boolean} [changeMonthYear=false] changeMonthYear
     * @property {number} [minYear=10] minYear
     * @property {number} [maxYear=10] maxYear
     * @property {external:moment} [minDate=null] minDate
     * @property {external:moment} [maxDate=null] maxDate
     * @property {number} [monthCount=1] monthCount
     * @property {HolidayCallback|array} [holiday=null] holiday
     * @property {DisabledCallback|array} [disabled=null] disabled
     * @property {string|array} [range=null] range
     * @property {boolean} [arrow=false] arrow
     * @property {boolean} [toggleAlert=true] toggleAlert
     * @property {DateFormat} [dateFormat='YYYY/MM/DD'] dateFormat
     * @property {Regex} [dataIsNumberRegex=/^\d[\d|\/]+\d$/] dataIsNumberRegex
     * @property {string} [moduleCloseEvent='cy_ln.close'] moduleCloseEvent
     * @property {external:moment} [weekdayName=moment.weekdaysMin()] weekdayName
     * @property {ClassConfig} [cssClass=ClassConfig] cssClass 
     * @property {AlertStringConfig} [alertString=AlertStringConfig] alertString 
     * 
     */

	Module.DEFAULTS = {
		hideArea: 'body',
		prev: '<a class="btn"></a>',                          // change prev button. html is allowed.
		next: '<a class="btn"></a>',                          // change next button. html is allowed.
		prevDisabled:'<a class="btn disabled"></a>',
		nextDisabled:'<a class="btn disabled"></a>',
		changeMonthYear: false,             // add dropdown list for month year
		minYear: 10,                      // minimum year of calendar. string or integer.
		maxYear: 10,                      // minimum year of calendar. string or integer.
		minDate: null,                      // minimum date of calendar. date string or integer.
		maxDate: null,                      // maximum date of calendar. date string or integer.
		monthCount: 1,                      // displaying month count
		single:false,						//直接打開選項
		showWeekName:false,					//顯示星期
		/**
         * callback HolidayCallback function description
         * @callback HolidayCallback
         * 
         * @param {external:moment} moment object
         * @return {boolean} true|false
         */
		holiday: null,                      // array ['YYYY/MM/DD'] or function(moment) { return false }
		/**
         * callback DisabledCallback function description
         * @callback DisabledCallback
         * 
         * @param {external:moment} moment object
         * @return {boolean} true|false
         */
		disabled: null,                     // function(moment) { return true; } or [function, function, ...]
		range: null,                        // '#text' or ['#text2', '#text3', 'text4']
		arrow: false,						// true or false, add an arrow at top of the module
		btnDisabled:false,
		renderValidMonth: false,	//only render months with abled months
		toggleAlert: true,
		dateFormat: 'YYYY/MM/DD',
		dataIsNumberRegex: /^\d[\d|\/]+\d$/,
		moduleCloseEvent: 'cy_ln.close',
		weekdayName: moment.weekdaysMin(),  // array of weekdayName
		/**
         * PluginOption.ClassConfig description
         * 
         * @typedef ClassConfig
         * @type {object}
         * @example
cssClass: {
 	main: 'cy-ln',
	wrapper: 'wrapper',
	month: 'month',
	prev: 'prev',
	yearMonth: 'yearMonth',
	next: 'next',
	weekdayName: 'weekdayName',
	date: 'date',
	weekday: [ 'sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
	holiday: 'holiday',
	today: 'today',
	hover: 'hover',
	disabled: 'disabled',
	selected: 'selected',
	start: 'start',
	arrow: 'arrow',
	between: 'between',
	point: 'point',
	end: 'end'
}
         * @property {string} [main='cy-ln'] main
         * @property {string} [wrapper='wrapper'] wrapper
         * @property {string} [month='month'] month
         * @property {string} [prev='prev'] prev
         * @property {string} [yearMonth='yearMonth'] yearMonth
         * @property {string} [next='next'] next
         * @property {string} [weekdayName='weekdayName'] weekdayName
         * @property {string} [date='date'] date
         * @property {array} [weekday=[ 'sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat']] weekday
         * @property {string} [holiday=holiday] holiday
         * @property {string} [today=today] today
         * @property {string} [hover=hover] hover
         * @property {string} [disabled=disabled] disabled
         * @property {string} [selected=selected] selected
         * @property {string} [start=start] start
         * @property {string} [arrow=arrow] arrow
         * @property {string} [between=between] between
         * @property {string} [point=point] point
         * @property {string} [end=end] end
         * @property {string} [inputActive=active] inputActive
         * @property {number} [top=0] top
         */
		cssClass: {                         // You can change css class
			main: 'cy-ln',
			extra: '',
			wrapper: 'wrapper',
			month: 'month',
			prev: 'prev',
			yearMonth: 'yearMonth',
			next: 'next',
			weekdayName: 'weekdayName',
			date: 'date',
			weekday: [ 'sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
			holiday: 'holiday',
			today: 'today',
			hover: 'hover',
			disabled: 'disabled',
			selected: 'selected',
			start: 'start',
			arrow: 'arrow',
			between: 'between',
			point: 'point',
			end: 'end',
			inputActive: 'active',
			top: 0,
			left:0
		},
		/**
         * PluginOption.AlertStringConfig description
         * 
         * @typedef AlertStringConfig
         * @type {object}
         * @example
alertString: {
	invalid: '日期格式錯誤！',
	beforeMin: '日期必須大於{#Date}！',
	afterMax: '日期必須小於{#Date}！',
	fromMoreTo: '日期迄日不可小於起日'
}
         * @property {string} [invalid='日期格式錯誤！'] invalid
         * @property {string} [beforeMin='日期必須大於{#Date}！'] beforeMin
         * @property {string} [afterMax='日期必須小於{#Date}！'] afterMax
         * @property {string} [fromMoreTo='日期迄日不可小於起日'] fromMoreTo
         */
		alertString: {
			invalid: '日期格式錯誤！',
			beforeMin: '日期必須大於{#Date}！',
			afterMax: '日期必須小於{#Date}！',
			fromMoreTo: '日期迄日不可小於起日'
		},
		alignRight:false
	};

	Module.prototype.getOptions = function ( updateOption ) {
		return this.options;
	};

	Module.prototype.updateOption = function ( updateOption ) {
		$.extend(this.options, updateOption);
	};

	Module.prototype.getMomentMinDate = function () {
		return this.options.getMomentMinDate().add(1, 'days').format('YYYY/MM/DD');
	};

	Module.prototype.collectionIndexOf = function ( collection, value, predicate ) {
		for (var i = 0; i < collection.length; i++) {
			if(predicate(collection[i], value))
				return i;
		}
		return -1;
	};

	Module.prototype.isBetween = function ( target, moment1, moment2 ) {
		var from = moment.min(moment1, moment2);
		var to = moment.max(moment1, moment2);
		return (target.isAfter(from) && target.isBefore(to));
	};

	Module.prototype.equalsDatePart = function ( moment1, moment2 ) {
		return moment1.format("YYYY/MM/DD") == moment2.format("YYYY/MM/DD");
	};

	Module.prototype.comparer = function ( moment1, moment2 ) {
		if(moment1.isBefore(moment2)) return -1;
		if(moment1.isAfter(moment2)) return 1;
		return 0;
	};

	Module.prototype.tag = function ( name ) {
		return $('<' + name + '></' + name + '>')
	};

	Module.prototype.checkDateRepair = function ( $input ) {
		$input.val( this.dateAutoRepair( $input.val(), false ) );
	};

	Module.prototype.dateAutoRepair = function ( val, runAlert ,showWeek) {
		var date = '';
		var today = moment();
		var todayString = moment().format('YYYYMMDDd');
		var valString = val.replace(/\//g, '');
		var valStringTwoChar = valString.substring(0, 2);
		var minDate = this.options.minDate;
		var maxDate = this.options.maxDate;
		var minDateString = (!!minDate && minDate instanceof moment) ? minDate.format('YYYYMMDD') : null;
		var maxDateString = (!!maxDate && maxDate instanceof moment) ? maxDate.format('YYYYMMDD') : null;
		var nowYear = (new Date).getFullYear().toString();
		var replaceString = '';
		var todayWeek = new Date(val).getDay();
		//console.log(minDateString, maxDateString);
		if ( val.length > 0 ) {
			// console.log(this.dateValueStatus(val));
			switch( this.dateValueStatus(val) ) {
				case 'validAll':
					date = moment(valString).format(this.options.dateFormat);
				break;
				case 'validMonthDay':
					date = moment( nowYear + valString ).format(this.options.dateFormat);
				break;
				case 'validMonth':
					date = moment( nowYear + valStringTwoChar + '01' ).format(this.options.dateFormat);
					// console.log(date, moment(minDateString).isBefore(date.replace(/\//g, '')));

					if (runAlert) {
						alert(this.options.alertString.invalid);
					}
				break;
				case 'sameMin':
					date = moment(minDateString).add(1, 'd').format(this.options.dateFormat);
					if (runAlert) {
						if ( /\{#Date\}/.test( this.options.alertString.beforeMin ) ) {
							replaceString = moment(minDateString).format(this.options.dateFormat);
							alert( this.options.alertString.beforeMin.replace(/\{#Date\}/g, replaceString) );
						} else {
							alert(this.options.alertString.beforeMin);
						}
					}
				break;
				case 'beforeMin':
					date = moment(minDateString).add(1, 'd').format(this.options.dateFormat);
					if (runAlert) {
						if ( /\{#Date\}/.test( this.options.alertString.beforeMin ) ) {
							replaceString = moment(minDateString).format(this.options.dateFormat);
							alert( this.options.alertString.beforeMin.replace(/\{#Date\}/g, replaceString) );
						} else {
							alert(this.options.alertString.beforeMin);
						}
					}
				break;
				case 'sameMax':
					date = moment(maxDateString).format(this.options.dateFormat);
				break;
				case 'afterMax':
					date = moment(maxDateString).format(this.options.dateFormat);
					if (runAlert) {
						if ( /\{#Date\}/.test( this.options.alertString.afterMax ) ) {
							replaceString = moment(maxDateString).add(1, 'd').format(this.options.dateFormat);
							alert( this.options.alertString.afterMax.replace(/\{#Date\}/g, replaceString) );
						} else {
							alert(this.options.alertString.afterMax);
						}
					}
				break;
				case 'invalid':
					if ( minDateString !== null && moment( todayString ).isSameOrBefore( minDateString ) ) {
						date = moment(minDateString).add(1, 'd').format(this.options.dateFormat);
					} else if ( maxDateString !== null && moment( todayString ).isAfter( maxDateString ) ) {
						date = moment(maxDateString).format(this.options.dateFormat);
					} else {
						date = moment().format(this.options.dateFormat);
					}
					//console.log(date);
					if (runAlert) {
						alert(this.options.alertString.invalid);
					}
				break;
				default:
					date = moment().format(this.options.dateFormat);
				break;
			}
		}
		if(this.options.showWeekName){
			date = date + '(' + this.options.weekdayName[todayWeek] + ')';
		}
		return date;
	};

	Module.prototype.getPrevInputDom = function ( rangeIndex ) {
		var $prevDom;
		if ( rangeIndex === 0 ) {
			$prevDom = this.$input;
		} else {
			$prevDom = $(this.options.range[rangeIndex - 1]);
		}
		return $prevDom;
	};

	Module.prototype.getNextInputDom = function ( rangeIndex ) {
		var $prevDom;
		if ( !rangeIndex && this.options.range.length > 0 ) {
			$prevDom = $(this.options.range[0]);
		} else {
			$prevDom = $(this.options.range[rangeIndex + 1]);
		}
		return $prevDom;
	};

	Module.prototype.getAfterInputDom = function ( rangeIndex ) {
		var $prevDom = function(index) {
			var $dom = $(this.options.range[index]);
			for (var i = index+1;i < this.options.range.length;i++) {
				$dom.add( this.options.range[i] );
			}
			return $dom;
		}.call(this, !!rangeIndex ? rangeIndex : 0);
		return $prevDom;
	};

	Module.prototype.getAllInputDom = function ( rangeIndex ) {
		var $dom = $(this.$input);
		if ( !!this.options.range && typeof this.options.range === 'object' ) {
			for (var i = rangeIndex || 0;i < this.options.range.length;i++) {
				$dom = $dom.add( this.options.range[i] );
			}
		}
		return $dom;
	};

	Module.prototype.dateIsAllNumber = function ( val ) {
		return this.options.dataIsNumberRegex.test(val);
	};

	Module.prototype.dateValueStatus = function ( val ) {
		var date = null;
		var dateString = val.replace(/\//g, '');
		var dateStringMonthChar = dateString.substring(0, 2);
		var dateStringMonthCharToInt = parseInt(dateStringMonthChar);
		var dateStringDayChar = dateString.substring(2, 4) || null;
		var dateStringDayCharToInt = parseInt(dateStringDayChar);
		var minDate = this.options.minDate;
		var maxDate = this.options.maxDate;
		var minDateString = (!!minDate && minDate instanceof moment) ? minDate.format('YYYYMMDD') : null;
		var maxDateString = (!!maxDate && maxDate instanceof moment) ? maxDate.format('YYYYMMDD') : null;
		var nowYear = (new Date).getFullYear().toString();
		var valueStatus = '';
		if ( dateString.length > 0 ) {
			if ( this.dateIsAllNumber( dateString ) ) {
				if ( dateString.length == 8 && moment(dateString).isValid() ) {
					valueStatus = 'validAll';
				} else if ( dateString.length == 4 && dateStringMonthCharToInt <= 12 ) {
					if ( moment( nowYear + dateString ).isValid() ) {
						valueStatus = 'validMonthDay';
					} else if ( moment( nowYear + dateStringMonthChar + '01' ).isValid() ) {
						valueStatus = 'validMonth';
					} else {
						valueStatus = 'invalid';
					}
				} else {
					valueStatus = 'invalid';
				}
			} else {
				valueStatus = 'invalid';
			}
		} else {
			valueStatus = 'null';
		}
		if ( valueStatus === 'validAll' ) {
			date = moment(dateString).format('YYYYMMDD');
		} else if ( valueStatus === 'validMonthDay' ) {
			date = moment( nowYear + dateString ).format('YYYYMMDD');
		} else if ( valueStatus === 'validMonth' && moment( nowYear + dateString ).isValid() ) {
			date = moment( nowYear + dateStringMonthChar + '01' ).format('YYYYMMDD');
			// console.log( dateString,  moment( nowYear + dateString ).isValid() );
		} else {
			valueStatus = 'invalid';
		}
		if ( date !== null && minDateString !== null ) {
			// console.log(date, minDateString);
			if ( moment( date ).isSame( minDateString ) ) {
				// console.log(date);
				valueStatus = 'sameMin';
			} else if ( moment( date ).isBefore( minDateString ) ) {
				// console.log(date);
				valueStatus = 'beforeMin';
			}
		}

		if ( date !== null && maxDateString !== null ) {
			if ( moment( date ).isSame( maxDateString ) ) {
				valueStatus = 'sameMax';
			} else if ( moment( date ).isAfter( maxDateString ) ) {
				valueStatus = 'afterMax';
			}
		}
		return valueStatus;
	};

	Module.prototype.drawCalendar = function ( $input, newOption, selected, display ) {
		var table = this.tag('table');
		var tr = this.tag('tr');
		var self = this;
		var momentDisplay, momentForPrint;
		var minDateString = (newOption.getMomentMinDate()) ? newOption.getMomentMinDate().format('YYYYMMDD') : null;
		var maxDateString = (newOption.getMomentMaxDate()) ? newOption.getMomentMaxDate().format('YYYYMMDD') : null;
		console.log()
		if(newOption.single === true ){
			selected = $input.attr('data-date');
		}
		if( typeof display === 'string' ) {
			momentDisplay = moment(display.replace(/\W/g,''));
			momentForPrint = moment(display.replace(/\W/g,''));
		} else {
			momentDisplay = moment(display);
			momentForPrint = moment(display);
		}
		// var momentForPrint = moment(display).add(-Math.floor((newOption.monthCount - 1) / 2), 'M');
		for(var i = 0; i < newOption.monthCount; i++){
			tr.append(
				this.tag('td')
					.append(this.drawMonth($input, newOption, selected, momentForPrint.format(newOption.dateFormat)))
			);
			momentForPrint.add(1, 'M');
		}
		
		if(newOption.arrow){
			table.append(this.tag('span').addClass(newOption.cssClass.arrow));

			if(!$input.attr("data-range")){
				table.children("."+newOption.cssClass.arrow).css("left",$input.width() / 2 - 3);	
			}else{
				var arrowLeft = $(newOption.range).offset().left - $input.offset().left + $(newOption.range).width() / 2 - 6;
				table.children("."+newOption.cssClass.arrow).css("left",arrowLeft);
			}	
		}

		// disable prev, next arrow or not
		console.log('drawCalendar => selected :',selected)
		var firstDay = tr.find('>td:first table tr td[data-date]:first').attr('data-date').replace(/\W/g,'');
		var lastDay = tr.find('>td:last table tr td[data-date]:last').attr('data-date').replace(/\W/g,'');
		var minDate = moment(minDateString, "YYYYMMDD").add(1, "days").format("YYYYMMDD");
		if( newOption.btnDisabled == true && parseInt(firstDay)	<= parseInt(minDate) && parseInt(lastDay) >= parseInt(minDateString) ){
			tr.find('>td:first table tr td.' + newOption.cssClass.prev).html(newOption.prevDisabled);
		} else {
			tr.find('>td:first table tr td.' + newOption.cssClass.prev).html(newOption.prev).click(function () {
				$(this).parents('.' + newOption.cssClass.main).empty().append(
					self.drawCalendar($input, newOption, selected, momentDisplay.add(-1, 'M'))
				);
			});	
		}

		if( newOption.btnDisabled == true && parseInt(firstDay)	<= parseInt(maxDateString) && parseInt(lastDay) >= parseInt(maxDateString) ){
			tr.find('>td:last table tr td.' + newOption.cssClass.next).html(newOption.nextDisabled);
		} else {
			tr.find('>td:last table tr td.' + newOption.cssClass.next).html(newOption.next).click(function () {
				$(this).parents('.' + newOption.cssClass.main).empty().append(
					self.drawCalendar($input, newOption, selected, momentDisplay.add(1, 'M'))
				);
			});	
		}
		table.addClass(newOption.cssClass.wrapper).append(tr);
		return table;
	};

	Module.prototype.drawMonth = function ( $input, newOption, selected, display ) {
		var momentSelected = moment(selected.replace(/\W/g,''));
		var momentDisplay = moment(display.replace(/\W/g,''));
		var i = 0;
		var self = this;
		var $table = this.tag('table').addClass(newOption.cssClass.month).attr('data-date', momentDisplay.format(newOption.dateFormat)).append(
			this.tag('tr')
				.append(this.tag('td').addClass(newOption.cssClass.prev))
				// .append(this.tag('td').addClass(newOption.cssClass.yearMonth).text(momentDisplay.format('YYYY年M月')))
				.append(this.tag('td').addClass(newOption.cssClass.yearMonth).append('<span>' + momentDisplay.format('YYYY') + '</span>年<span>' + momentDisplay.format('M') + '</span>月'))
				.append(this.tag('td').addClass(newOption.cssClass.next))
		);
		console.log('drawMonth => selected: ',selected)
		console.log('drawMonth => momentSelected: ',momentSelected);
		if(newOption.monthCount == 1 && newOption.changeMonthYear){
			$table.find('.' + newOption.cssClass.yearMonth).empty();
			var $selectYear = this.tag('select');
			var minYear = typeof newOption.minYear === 'string' ? parseInt(newOption.minYear) : 
				( newOption.minYear > 200 ? newOption.minYear : momentDisplay.year() - newOption.minYear);
			var maxYear = typeof newOption.maxYear === 'string' ? parseInt(newOption.maxYear) : 
				( newOption.maxYear > 200 ? newOption.maxYear : momentDisplay.year() + newOption.maxYear);

			//console.log(newOption)
			//noinspection JSDuplicatedDeclaration
			for(i = minYear; i <= maxYear; i++) {
				if(i == momentDisplay.year()){
					$selectYear.append(this.tag('option').val(i).text(i).attr('selected', 'selected'));
				} else {
					$selectYear.append(this.tag('option').val(i).text(i));
				}
			}
			$table.find('.' + newOption.cssClass.yearMonth).append($selectYear);

			var $selectMonth = this.tag('select');
			//noinspection JSDuplicatedDeclaration
			
			var minDate = newOption.minDate;
			var maxDate = newOption.maxDate;
			if (!!newOption.minDate && typeof minDate == "number") minDate = moment().add(minDate, "days");
			if (!!newOption.maxDate && typeof maxDate == "number") maxDate = moment().add(maxDate, "days");
			var minDateString = minDate.format("YYYYMMDD");
			var maxDateString = maxDate.format("YYYYMMDD");
			var minMonth = 0;
			var maxMonth = 12;
			minDate = minDate.clone();
			minDate.add(1, "days");
			maxDate = maxDate.clone();
			maxDate.add(1, "days");

			if (newOption.renderValidMonth == true && (typeof minDate == "object" && typeof maxDate == "object" )) {
				if ($selectYear.val() == minDate.year() == maxDate.year()) {
					minMonth = minDate.month();
					maxMonth = maxDate.month() + 1;
				}else if($selectYear.val() == minDate.year() && $selectYear.val() < maxDate.year()) {
					minMonth = minDate.month();
				}else if($selectYear.val() == maxDate.year()) {
					maxMonth = maxDate.month() + 1;
				}else {}
			}else {}

			for(i = minMonth; i < maxMonth; i++) {
				if(i == momentDisplay.month()) {
					$selectMonth.append(this.tag('option').val(i).text(i + 1).attr('selected', 'selected'));
				} else {
					$selectMonth.append(this.tag('option').val(i).text(i + 1));
				}
			}

			$selectYear.change(function() {
				$(this).parents('.' + newOption.cssClass.main).empty().append(self.drawCalendar($input, newOption, selected, self.dateAutoRepair( momentDisplay.year($(this).val()).format("YYYYMMDD"), newOption.toggleAlert )));
				
			});
			$selectMonth.change(function () {
				$(this).parents('.' + newOption.cssClass.main).empty().append(self.drawCalendar($input, newOption, selected, self.dateAutoRepair( momentDisplay.month(parseInt($(this).val())).format("YYYYMMDD"), newOption.toggleAlert )));
			});
			$table.find('.' + newOption.cssClass.yearMonth).append($selectMonth);

		}
		var $trForWeekHeader = this.tag('tr').appendTo($table);
		//noinspection JSDuplicatedDeclaration
		for(i = 0; i < 7; i++) {
			$trForWeekHeader.append(this.tag('th').addClass(newOption.cssClass.weekdayName).addClass(newOption.cssClass.weekday[i]).text(newOption.weekdayName[i]));
		}


		var momentFirstDayOfMonth = moment(momentDisplay).startOf('month');
		var momentLastDayOfMonth = moment(momentDisplay).endOf('month');
		var firstDayOfWeek = momentFirstDayOfMonth.day();
		var lastDay = momentLastDayOfMonth.date();

		var $tr = this.tag('tr').appendTo($table);
		var weekday = 0;

		//noinspection JSDuplicatedDeclaration
		for(i = 0; i < firstDayOfWeek; i++) {
			$tr.append(this.tag('td').addClass(newOption.cssClass.date));
			weekday++;
		}
		var momentForPrint = moment(momentFirstDayOfMonth);
		//noinspection JSDuplicatedDeclaration
		for(i = 1; i <= lastDay; i++) {
			momentForPrint.date(i);
			var dataRange = parseInt($input.attr('data-range'));
			var $td = this.tag('td')
			.attr('data-date', momentForPrint.format(newOption.dateFormat))
			.text(momentForPrint.date())
			.addClass(newOption.cssClass.date)
			.addClass(moment(new Date()).format(newOption.dateFormat) == momentForPrint.format(newOption.dateFormat) ? newOption.cssClass.today : '')
			.addClass(momentSelected.format(newOption.dateFormat) == momentForPrint.format(newOption.dateFormat) ? newOption.cssClass.selected : '')
			.addClass(newOption.cssClass.weekday[weekday])
			.addClass(newOption.isHoliday(momentForPrint) ? newOption.cssClass.holiday : "")
			.addClass(newOption.isDisabled(momentForPrint, isNaN(dataRange) ? -1 : dataRange) ? newOption.cssClass.disabled : "")
			.on('click', function (e) {
				e.stopPropagation();
				var $this = $(this);
				var range = parseInt($input.attr('data-range'));
				var clickedDateString = $this.attr('data-date');
				var prevDateString;
				var nextDateString;
				if($this.hasClass(newOption.cssClass.disabled)) {
					return;
				}
				if($(e.target).closest('.cy-ln').attr('data-Fix')==='true'){
					$('td').removeClass('selected');
					$this.addClass('selected');
					var val = self.dateAutoRepair( $this.attr('data-date') || moment().format(newOption.dateFormat) ) ;
					$input.text('出發日期：'+val).attr('data-date',val)
					return;
				}
				if( !newOption.range) {
					$input.val($this.attr('data-date')).trigger('change');
					self.close( $input );
					return;
				}

				if( !$input.attr('data-range') ) {
					$input.val($this.attr('data-date')).attr('data-range', 0).removeClass(newOption.cssClass.inputActive).trigger('change');
					if ( self.comparer( moment($input.val().replace(/\//g, '')), moment(self.getNextInputDom(range).val().replace(/\//g, '')) ) === 1 ) {
						self.getAfterInputDom( range ).val('');
					}
					self.getAfterInputDom( range ).addClass(newOption.cssClass.inputActive);
					if(newOption.arrow) {
						var value3 =  $(newOption.range).offset().left - $input.offset().left + $(newOption.range).width() + 28;
						if($input.offset().top == $(newOption.range).offset().top && value3 < $('.cy-ln').width()){
							var arrowLeft = $(newOption.range).offset().left - $('.cy-ln').offset().left + $(newOption.range).width() / 2 - 6; //減掉箭頭寬度一半
							$('.'+newOption.cssClass.arrow).css({
								left: arrowLeft 
							});
						}else{
							clearInterval(self.timer);
							self.timer = setInterval(function(){
								$('.cy-ln').css({
									left: $(newOption.range).offset().left, top: $(newOption.range).offset().top + $input.outerHeight()
								});
							},25);
						}
					}
					$this.trigger('mouseenter');
					return;
				}

				prevDateString = self.getPrevInputDom(range).val();
				if ( self.comparer( moment(prevDateString.replace(/\//g, '')), moment(clickedDateString.replace(/\//g, '')) ) === 1 || self.getPrevInputDom(range).val() === '' ) {
					self.getPrevInputDom( range ).val( clickedDateString );
					self.getAfterInputDom( range ).val('');
					//self.getAfterInputDom( range ).val('');
					return;
				}

				$(newOption.range[range]).val($this.attr('data-date')).trigger('change');
				self.getPrevInputDom( range ).removeClass(newOption.cssClass.inputActive);
				if ( range < newOption.range.length - 1 ) {
					range++;
					$input.attr('data-range', range);
					$this.trigger('mouseenter');
				} else {
					self.close($input);
				}
			})
			.on('mouseenter', function (e) {
				var $this = $(this);
				var movedDateString = $this.attr('data-date'); //日期字串
			// if(self.$input[0].nextSibling === $(e.target).closest('.cy-ln')[0]){
				var $nowInput = function(rangeIndex) {
					if ( !!rangeIndex ) {
						return $( newOption.range[rangeIndex] );
					} else {
						return $input;
					}
				}($input.attr('data-range'));
				var range = function(rangeStringNumber) {
					if ( rangeStringNumber ) {
						return parseInt(rangeStringNumber);
					} else {
						return false;
					}
				}( $input.attr('data-range') );
				var prevDateString;
				if($(this).hasClass(newOption.cssClass.disabled)) {
					return;
				}
				$(this).addClass(newOption.cssClass.hover);
				if(!newOption.range) {
					return;
				}
				prevDateString = self.getPrevInputDom(range).val();
				if ( !!prevDateString && self.comparer(
					moment(prevDateString.replace(/\//g, '')),
					moment(movedDateString.replace(/\//g, ''))
				) === 1 ) {
					console.log('before date!!!');
					if ( $nowInput.hasClass(newOption.cssClass.inputActive) ) {
						$nowInput.removeClass(newOption.cssClass.inputActive);
						self.getPrevInputDom(range).addClass(newOption.cssClass.inputActive);
					}
				} else {
					console.log('after date!!!');
					if ( !$nowInput.hasClass(newOption.cssClass.inputActive) ) {
						$nowInput.addClass(newOption.cssClass.inputActive);
						self.getPrevInputDom(range).removeClass(newOption.cssClass.inputActive);
					}
				}

				if(newOption.range) {
					var dataRange = parseInt($input.attr('data-range'));
					var arrayMoment = self.getArrayMoment(isNaN(dataRange) ? -1 : dataRange);
					arrayMoment.push(moment($(this).attr('data-date').replace(/\W/g,'')));
					self.refreshDateForPeriod(arrayMoment , $(e.target).closest('.cy-ln')[0]);
				}
			// }
			})
			.on('mouseleave', function () {
				if($(this).hasClass(newOption.cssClass.disabled)) {
					return;
				}
				$(this).removeClass(newOption.cssClass.hover);
			});

			$tr.append($td);
			weekday = (weekday + 1) % 7;
			if(weekday == 0) {
				$tr = this.tag('tr').appendTo($table);
			}
		}

		return $table;
	};

	Module.prototype.getArrayInput = function ( except, $input ) {
		var array = [$input];
		if(except == -1)
			array = [];

		$.each(this.options.range, function ( index, value ) {
			if(typeof except == 'number' && except == index) {
				return;
			}

			array.push($(value));
		});
		// console.log(array);
		return array;
	};

	Module.prototype.getArrayMoment = function ( except ) {
		var array = [];
		$.each(this.getArrayInput(except, this.$input), function (index, value) {
			var momentValue = moment($(value).val().replace(/\W/g,''));
			if(!momentValue.isValid())
				return;

			array.push(momentValue);
		});

		return array;
	};

	Module.prototype.refreshDateForPeriod = function ( arrayMoment , ele ) {
		var momentFrom = arrayMoment[0];
		var momentTo = arrayMoment[arrayMoment.length - 1];
		var self = this;
		if(arrayMoment.length == 0) {
			return;
		}
		arrayMoment.sort(this.comparer);
		// $('.' + this.options.cssClass.main + ' .' + this.options.cssClass.date).each(function (index, value) {
		$(ele).find('td.date').each(function (index, value) {
			var $date = $(value);
			var dataDate = $date.attr('data-date');
			if(!dataDate)
				return;

			var dataRange = parseInt(self.$input.attr('data-range'));

			var momentDate = moment(dataDate.replace(/\W/g,''));
			$date
				.removeClass(self.options.cssClass.disabled)
				.removeClass(self.options.cssClass.selected)
				.removeClass(self.options.cssClass.start)
				.removeClass(self.options.cssClass.between)
				.removeClass(self.options.cssClass.point)
				.removeClass(self.options.cssClass.end)
				.addClass(self.options.isDisabled(momentDate, isNaN(dataRange) ? -1 : dataRange) ? self.options.cssClass.disabled : "");
			if(self.equalsDatePart(momentDate, momentFrom)) {
				$date.addClass(self.options.cssClass.between).addClass(self.options.cssClass.start);
			} else if(self.equalsDatePart(momentDate, momentTo)) {
				$date.addClass(self.options.cssClass.between).addClass(self.options.cssClass.end);
			} else if(self.isBetween(momentDate, momentFrom, momentTo)){
				if(-1 == self.collectionIndexOf(arrayMoment, momentDate, self.equalsDatePart)) {
					$date.addClass(self.options.cssClass.between);
				} else {
					$date.addClass(self.options.cssClass.between).addClass(self.options.cssClass.point);
				}
			} else {
				// do nothing.
			}
		});
	};

	Module.prototype.close = function (e) {
		console.log('run close');
		$('.' + this.options.cssClass.main).not('[data-fix=true]').remove();
		this.getAllInputDom().removeClass(this.options.cssClass.inputActive);
		clearInterval(this.timer);
	}

	Module.prototype.SingleInput = function(ele,opt,module) {
		var title = $(ele);
		var $body = $('.container');
		var offset = ele.offset();
		var val = module.dateAutoRepair( ele.text().substring(5) || moment().format(opt.dateFormat) ) ;
		var minValue = function(inputValue, minDate) {
			var date;
			if ( !!minDate && minDate.isValid() ) {
				date = moment( minDate ).format(opt.dateFormat);
			} else {
				date = moment().format(opt.dateFormat);
			}
			return date;
		}( ele.val(), opt.minDate );
		var $ele = module.tag('div');
		var displayDate = function(a, b){
			var inputValueBeforeMin = moment( a.replace(/\//g, '') ).isBefore( b.replace(/\//g, '') );
			if ( inputValueBeforeMin ) {
				return b;
			} else {
				return a;
			}
		}(val, minValue);
		// module.close();
		module.getAllInputDom().removeClass(opt.cssClass.inputActive);
		if ( typeof rangeIndex === 'number' ) {
			ele.attr('data-range', rangeIndex);
			$(opt.range[rangeIndex]).addClass(opt.cssClass.inputActive);
		} else {
			ele.attr('data-range', null).addClass(opt.cssClass.inputActive);
		}
		$(ele).attr('data-date',val);
		$(title).after(
			$ele.addClass( opt.cssClass.main + ' ' +  opt.cssClass.extra).append( module.drawCalendar(ele, opt, val, displayDate) ).attr('data-fix',true)
		).text('出發日期：'+val); //初始
		// var CylnCssOption = {
		// 	top: 0,
		// 	left:0
		// };

		// $ele.css( CylnCssOption ).find('.arrow').css( {
		// 	left: ele.offset().left - $('.cy-ln').offset().left + (ele.width() / 2) - 3
		// } );
		// var input = this.input;
		// var $input = $(input);
		// var $span = $(input).prev();
		// $input.css({'padding':'0','padding':'0 0 13px 92px','height':'45px','width': '224.45px'});
		// $span.css({'text-align':'right','width':'6.5em','padding':'0','height':'45px','line-height':'35px'});


	}

	/**
     * cy_ln - an awesome jQuery plugin. 
     * @function external:"jQuery.fn".cy_ln
     *
     * @param {PluginOption} option
     * 
     * @example

$('#test').cy_ln({
	hideArea: 'body',
	prev: '<a class="btn"></a>',
	next: '<a class="btn"></a>',
	changeMonthYear: false,
	minYear: 10,
	maxYear: 10,
	minDate: null,
	maxDate: null,
	monthCount: 1,
	holiday: null,
	disabled: null,
	range: null,
	arrow: false,
	toggleAlert: true,
	dateFormat: 'YYYY/MM/DD',
	dataIsNumberRegex: /^\d[\d|\/]+\d$/,
	moduleCloseEvent: 'cy_ln.close',
	weekdayName: moment.weekdaysMin(),
	cssClass: {
		main: 'cy-ln',
		wrapper: 'wrapper',
		month: 'month',
		prev: 'prev',
		yearMonth: 'yearMonth',
		next: 'next',
		weekdayName: 'weekdayName',
		date: 'date',
		weekday: [ 'sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
		holiday: 'holiday',
		today: 'today',
		hover: 'hover',
		disabled: 'disabled',
		selected: 'selected',
		start: 'start',
		arrow: 'arrow',
		between: 'between',
		point: 'point',
		end: 'end'
	},
	alertString: {
		invalid: '日期格式錯誤！',
		beforeMin: '日期必須大於{#Date}！',
		afterMax: '日期必須小於{#Date}！',
		fromMoreTo: '日期迄日不可小於起日'
	}
});

     * @returns {external:jQuery} Object
     */

    /**
     * getOptions description...
     * @function external:"jQuery.fn".cy_ln
     * @param {string} 'getOptions' run getOptions method
     * @return {PluginOption} PluginOption return PluginOption
     * 
     */
    /**
     * updateOption description...
     * @function external:"jQuery.fn".cy_ln
     * @param {string} 'updateOption' run updateOption method'
     * 
     */
	$.fn[ModuleName] = function(option, stringOpts) {
		return this.each(function(){
			var $this = $(this);
			var module = $this.data( ModuleName );
			var newOption = null;
			if ( !!module ) {
				if ( typeof option === 'string' &&  typeof stringOpts === 'undefined' ) {
					module[option]();
				} else if ( typeof option === 'string' &&  typeof stringOpts === 'object' ) {
					module[option](stringOpts);
				} else {
					console.log('unsupported options!');
					throw 'unsupported options!';
				}
			} else {
				newOption = $.extend( true,	{},	Module.DEFAULTS, {
					getMomentMinDate : function () {
						if (this.minDate == null) {
							return null;
						}

						if ($.isNumeric(newOption.minDate)) {
							return moment().add(newOption.minDate, 'd');
						}

						if (this.minDate != null) {
							return moment(newOption.minDate);
						}
					},
					getMomentMaxDate : function () {
						if (newOption.maxDate == null) {
							return null;
						}

						if ($.isNumeric(newOption.maxDate)) {
							return moment().add(newOption.maxDate, 'd');
						}

						if (this.maxDate != null) {
							return moment(newOption.maxDate);
						}
					},
					isDisabled: function (moment, index) {
						var momentMinDate = this.getMomentMinDate();
						var momentMaxDate = this.getMomentMaxDate();
						//console.log(moment.format('YYYYMMDD'), momentMinDate.format('YYYYMMDD'), momentMaxDate.format('YYYYMMDD'), moment.isBefore(momentMinDate), moment.isAfter(momentMaxDate));

						if(momentMinDate != null && moment.isSameOrBefore(momentMinDate))
							return true;

						if(momentMaxDate != null && moment.isAfter(momentMaxDate))
							return true;

						if($.isFunction(this.disabled) && this.disabled(moment))
							return true;

						//noinspection RedundantIfStatementJS
						if ($.isArray(this.disabled) && this.disabled[index + 1](moment))
							return true;

						return false;
					},
					isHoliday: function (moment) {
						if($.isFunction(this.holiday) && this.holiday(moment))
							return true;

						//noinspection RedundantIfStatementJS
						if($.isArray(this.holiday) && 0 <= $.inArray(moment.format('YYYY/MM/DD'), newOption.holiday))
							return true;

						return false;
					}
				}, ( typeof option === 'object' && option ) );
				module = new Module(this, newOption);
				$this.data( ModuleName, module );

				if($.type(newOption.range) == 'string') {
					newOption.range = [ newOption.range ];
				}
				(function ($input, newOption) {
					if(newOption.single){
						module.SingleInput($input,newOption,module);
						$input.attr('disabled',true);
						return;
					}
					$($input).on('click', function (e, rangeIndex) {
						e.stopPropagation();
						var $body = $('body');
						var offset = $input.offset();
						var val = module.dateAutoRepair( $input.val() || moment().format(newOption.dateFormat) ) ;
						var minValue = function(inputValue, minDate) {
							var date;
							if ( !!minDate && minDate.isValid() ) {
								date = moment( minDate ).format(newOption.dateFormat);
							} else {
								date = moment().format(newOption.dateFormat);
							}
							return date;
						}( $input.val(), newOption.minDate );
						var $ele = module.tag('div');
						var displayDate = function(a, b){
							var inputValueBeforeMin = moment( a.replace(/\//g, '') ).isBefore( b.replace(/\//g, '') );
							if ( inputValueBeforeMin ) {
								return b;
							} else {
								return a;
							}
						}(val, minValue);
						module.close($input);
						module.getAllInputDom().removeClass(newOption.cssClass.inputActive);
						if ( typeof rangeIndex === 'number' ) {
							$input.attr('data-range', rangeIndex);
							$(newOption.range[rangeIndex]).addClass(newOption.cssClass.inputActive);
						} else {
							$input.attr('data-range', null).addClass(newOption.cssClass.inputActive);
						}

						$body.one( 'click', function(e) {
							module.close( $input );
						} ).append(
							$ele.addClass( newOption.cssClass.main + ' ' +  newOption.cssClass.extra).css({
								position: 'absolute',
								'z-index': '10001'
							}).append( module.drawCalendar($input, newOption, val, displayDate) )
						);

						console.log($ele.outerWidth(),$input.outerWidth());

						var CylnCssOption = {
							left: (newOption.alignRight) ?	offset.left- ($ele.outerWidth()- $input.outerWidth())+ newOption.cssClass.left : offset.left+ newOption.cssClass.left,
							top: offset.top+ newOption.cssClass.top+ $input.outerHeight(),
						};

						$ele.css( CylnCssOption ).find('.arrow').css( {
							left: $input.offset().left - $('.cy-ln').offset().left + ($input.width() / 2) - 3
						} );

						// if(newOption.arrow){
						// 	$ele.css({
						// 		left: $input.offset().left + newOption.cssClass.left , top: $input.offset().top + newOption.cssClass.top + $input.outerHeight() ,
						// 		position: 'absolute','z-index':'10001'
						// 	});
						// }

						module.timer = setInterval(function() {
							var left = $input.offset().left + newOption.cssClass.left;
							$ele.css({
								left: (newOption.alignRight) ?	left- ($ele.outerWidth()- $input.outerWidth()) : left , 
								top: $input.offset().top + newOption.cssClass.top + $input.outerHeight()
							})
						},25);
						
						$('.cy-ln').on('click', function (e) {
							e.stopPropagation();
						});

						if(newOption.range) {
							var arrayMoment = module.getArrayMoment();
							module.refreshDateForPeriod(arrayMoment , $ele);
						}

					}).on('keydown', function (e) {
						//console.log('keydown');
						if(!$(this).is(":focus")) {
							module.close();
						}

						if(e.keyCode === 9) {
							module.close();
						}
					}).on('change', function () {
						var weekdayName = module.options.weekdayName;
						var inputValue = $(this).val();
						var dateRepairedString = module.dateAutoRepair(inputValue, newOption.toggleAlert);
						$(this).val(dateRepairedString);
					}).on('checkDateRepair', function() {
						module.checkDateRepair( $(this) );
					}).on('checkDateStatus', function(e, returnStatus) {
						returnStatus.status = module.dateValueStatus(returnStatus.date);
					});

					if( !!newOption.range && $.type(newOption.range) === 'array' ) {
						$.each(newOption.range, function (index, value) {
							$(value).on('focusin', function () {
								console.log(index);
								$input.trigger('click', [index]);
							}).on('keydown', function (e) {
								if(!$(this).is(":focus"))
									module.close();
								if(e.keyCode === 9)
									module.close();
							}).on('click',function(e){
								e.stopPropagation();
							}).on('change', function(e) {
								var inputValue = $(this).val();
								var dateRepairedString = module.dateAutoRepair(inputValue, newOption.toggleAlert);
								var dateFrom = $input.val().replace(/\//g, '');
								var dateTo = dateRepairedString.replace(/\//g, '');
								var canCompared = !!dateFrom && moment(dateFrom).isValid() && !!dateTo && moment(dateTo).isValid();
								if ( !!canCompared && moment(dateFrom).isAfter(dateTo) ) {
									$(this).val( moment(dateFrom).add(1, 'd').format(newOption.dateFormat) );
								} else {
									$(this).val(dateRepairedString);
								}
							}).on('checkDateRepair', function() {
								module.checkDateRepair( $(this) );
							}).on('checkDateStatus', function(e, returnStatus) {
								returnStatus.status = module.dateValueStatus(returnStatus.date);
							});
						});
					}

				})( $this, module.options );
			}
		});
	};
	
	$(function(){
		var $modules = $('[data-toggle="cy-ln"]');

		$modules.each(function(index,dom){
			var $this = $(this),
				isShowWeekName = ($this.attr("data-showWeekName") == 'true')? true : false,
				isSingle = ($this.attr("data-single") == 'true')? true : false,
				isRangeRole = ($this.attr("data-role") == "range"),
				needRange = ($this.attr('data-cy-ln') == 'range')? true : false,
				needArrow = ($this.attr('data-arrow') == 'true') || false,
				changeMonthYear = ($this.attr("data-change") == "true") || false,
				minDateFromToday = typeof $this.attr("data-minDate") !== 'undefined' ? $this.attr("data-minDate") : null,
				maxDateFromToday = typeof $this.attr("data-maxDate") !== 'undefined' ? $this.attr("data-maxDate") : null,
				isAlert = ($this.attr('data-toggleAlert') == 'true') || false,
				alertStringInvalid = typeof $this.attr('data-invalidAlert') !== 'undefined' ? $this.attr('data-invalidAlert') : '日期格式錯誤！',
				alertStringbeforeMin = typeof $this.attr('data-beforeMinAlert') !== 'undefined' ? $this.attr('data-beforeMinAlert') : '日期必須大於{#Date}！',
				alertStringafterMax = typeof $this.attr('data-afterMaxAlert') !== 'undefined' ? $this.attr('data-afterMaxAlert') : '日期必須小於{#Date}！',
				alertStringFromMoreTo = typeof $this.attr('data-fromMoreTo') !== 'undefined' ? $this.attr('data-fromMoreTo') : '日期迄日不可小於起日';
			if ( !isRangeRole ) {
				var $rangeRoles = [];
				for (var i = index+1; i < $modules.length; i++) {
					if($modules.eq(i).attr("data-role") != "range") {break;}
					$rangeRoles.push($modules.eq(i)[0]);
				}
				$this.cy_ln({
					showWeekName:!!isShowWeekName ? true : false,
					single:!!isSingle ? true : false,
					monthCount: !!needRange ? 2 : 1,
					range: !!needRange ? $rangeRoles : null,
					arrow: !!needArrow ? true : false,
					btnDisabled:false,
					minDate: !!minDateFromToday ? moment().subtract(parseInt(minDateFromToday), 'days') : null,
					maxDate: !!maxDateFromToday ? moment().add(parseInt(maxDateFromToday), 'days') : null,
					weekdayName: ['日','一','二','三','四','五','六'],
					changeMonthYear: !!changeMonthYear ? true : false,
					toggleAlert: isAlert,
					alertString: {
						invalid: alertStringInvalid,
						beforeMin: alertStringbeforeMin,
						afterMax: alertStringafterMax,
						fromMoreTo: alertStringFromMoreTo
					}
				});
			}
		});
	});
})(jQuery, moment);


// WEBPACK FOOTER //
// ./magaele/cy-ln/module.js